'use client'

import { initAuthConfig, getAmplifyBackend, isAuthConfigInitialized } from '@nestingale/auth'
import { resolveConfig, type BrandKey } from '@/config/configService'
import { getBrand } from '@/config/brandDetection'

/**
 * Initialize @nestingale/auth config from configService, then configure Amplify v6.
 * This is a standalone utility — no provider context needed.
 *
 * The active brand is auto-detected from the URL via `getBrand()`.
 * Pass an explicit `brand` to override.
 *
 * Safe to call multiple times; initAuthConfig is idempotent when config hasn't changed.
 */
export const configureAmplify = (brand?: BrandKey) => {
  try {
    if (isAuthConfigInitialized()) return true

    const activeBrand = brand ?? getBrand()

    const amplify = resolveConfig('amplify', activeBrand)
    const google = resolveConfig('google', activeBrand)
    const apple = resolveConfig('apple', activeBrand)

    initAuthConfig({
      amplify,
      google,
      apple,
      apiBaseUrl: 'https://nestingale.com',
    })

    const backend = getAmplifyBackend()
    backend.configure()
    console.log(`configureAmplify: initiated via @nestingale/auth v6 (brand: ${activeBrand})`)
    return true
  } catch (error) {
    console.error('Error configuring Amplify:', error)
    return false
  }
}